import { PaymentError } from '../core/payment-error';

export const requireResponse = <T>(response: T | null | undefined): T => {
    if (response === undefined || response === null) {
        throw new PaymentError(
            'Received an empty response from the payment service. Please try again.',
            'API_ERROR'
        );
    }

    return response;
};

export const responseOrDefault = <T>(
    response: T | null | undefined,
    fallback: T
): T => response ?? fallback;
